(() => {
  'use strict';

  // Quantity steppers for the cart page. The markup is a real <form action="/cart" method="post">
  // with `updates[]` inputs, so this only replaces the manual "Update cart" press with an
  // automatic submit — with JS off, the <noscript> button does exactly the same thing.
  function init(form) {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    function submitSoon() {
      // Debounced so holding + / − doesn't fire one page reload per click.
      clearTimeout(form._meningeaTimer);
      form._meningeaTimer = setTimeout(() => form.submit(), 350);
    }

    form.addEventListener('click', (event) => {
      const step = event.target.closest('[data-qty-step]');
      if (!step) return;

      const row = step.closest('[data-cart-row]');
      const input = row?.querySelector('[data-qty-input]');
      if (!input) return;

      const min = Number(input.min || 0);
      const max = Number(input.max || 99);
      const next = clamp(Number(input.value) + Number(step.dataset.qtyStep), min, max);

      if (next === Number(input.value)) return;
      input.value = String(next);
      submitSoon();
    });

    form.addEventListener('change', (event) => {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;

      const min = Number(input.min || 0);
      const max = Number(input.max || 99);
      const parsed = Number(input.value);

      input.value = String(Number.isFinite(parsed) ? clamp(parsed, min, max) : min);
      submitSoon();
    });
  }

  document.querySelectorAll('[data-meningea-cart]').forEach(init);
})();
